import { getFilmOtt } from '../utils/get-film-ott';
import { transformConcurrencyArbiterConfig } from '../../movie-player/transformers/transform-concurrency-arbiter-config';

import { useReadFilmPlayerBaseInfo } from './use-read-film-player-base-info';

export const useFilmConcurrencyArbiterConfig = (contentId: string) => {
    const filmOrVideo = useReadFilmPlayerBaseInfo(contentId);
    const ott = filmOrVideo && getFilmOtt(filmOrVideo);
    const concurrencyArbiterConfig = ott?.onlineStreams?.concurrencyArbiterConfig;

    return concurrencyArbiterConfig
        ? transformConcurrencyArbiterConfig(concurrencyArbiterConfig)
        : undefined;
};
